import {
    useState,
    useCallback,
    useEffect
} from 'react';
import {
    Container,
    Title,
    Content,
    ListHolidays,
    BoxSelect,
    BtnSearch
} from './styled';
import {
    FaRegCalendarAlt
} from "react-icons/fa";
import {
    Search,
    Modal,
    DatePicker
} from '../../../../components';
import moment from 'moment';
import { IoIosSearch } from 'react-icons/io';
import { HolidaysForm } from './Components/HolidaysForm';
import { CardHolidays } from './Components/CardHolidays';
import { getHolidays } from '../../../../service/serviceChat/holidayService';

export function Holidays() {

    const [holiday, setHoliday] = useState([]);
    const [filter, setFilter] = useState('');
    const [settingsModal, setSettingsModal] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dateStart, setDateStart] = useState(
        moment().subtract(2, 'year').startOf('year').format('YYYY-MM-DD')
    );
    const [dateEnd, setDateEnd] = useState(
        moment().endOf('year').format('YYYY-MM-DD')
    );

    function onFilter(obj) {
        return (obj?.nome?.toLowerCase()?.includes(filter?.toLowerCase()) 
        || obj?.mensagem?.toLowerCase()?.includes(filter?.toLowerCase()));
    }

    const searchHolidays = useCallback(async (dt_start, dt_end) => {
        const response = await getHolidays(dt_start, dt_end);
        setHoliday(response);
        setLoading(false);

    }, []);

    useEffect(() => {
        searchHolidays(dateStart, dateEnd);
    }, []);

    const handleNewHoliday = () => {
        setSettingsModal({
            action: 'createHoliday',
            data: null,
        });
    };

    const handleConfigHoliday = (holiday) => {
        setSettingsModal({
            action: 'configHoliday',
            data: holiday,
        });
    };

    return (
        <Container>
            <BoxSelect>
                <div className='box--'>
                    <div className='line-'>
                        <DatePicker
                            className="date"
                            value={dateStart}
                            onChange={setDateStart}
                        />
                        <span> - </span>
                        <DatePicker
                            className="date"
                            value={dateEnd}
                            onChange={setDateEnd}
                        />
                        <BtnSearch
                            disabled={loading ? 1 : 0}
                            onClick={() => {
                                setLoading(true);
                                searchHolidays(dateStart, dateEnd);
                            }}
                        >
                            {loading
                                ? <span className='loader' />
                                : <IoIosSearch />
                            }
                        </BtnSearch>
                    </div>
                </div>
            </BoxSelect>
            <Title>
                <span>
                    <FaRegCalendarAlt fontSize={'3rem'} />
                </span>
                <div>
                    {`Listagem de Feriados `}
                </ div>
            </Title>

            <Content>
                <div>
                    <Search
                        className={`uFN`}
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        placeholder={`Buscar Feriado`}
                    />
                    <button onClick={() => handleNewHoliday()}>
                        <FaRegCalendarAlt fontSize={'1.5rem'} />
                        {`Novo Feriado`}
                    </button>
                </div>
                <ListHolidays>
                    <div>
                        <div>
                            {`Data`}
                        </div>
                        <div>
                            {`Feriado`}
                        </div>
                        <div>
                            {`Mensagem`}
                        </div>
                    </div>
                    <ul>
                        {holiday.length > 0 &&
                            holiday
                                .slice()
                                .reverse()
                                .filter(onFilter)
                                .map((item) => {
                                    return (
                                        <CardHolidays
                                            key={item?.id}
                                            holiday={item}
                                            onClick={() => handleConfigHoliday(item)}
                                        />
                                    );
                                })}
                    </ul>
                </ListHolidays>
            </Content>
            <Modal
                title={`${settingsModal?.action === 'createHoliday' ? 'Novo' : 'Configurar'} Feriado`}
                isOpen={settingsModal}
                close={() => setSettingsModal(null)}
            >
                {(settingsModal) && (
                    <HolidaysForm
                        holiday={settingsModal?.data}
                        callback={() => {
                            searchHolidays(dateStart, dateEnd);
                            setSettingsModal(null);
                        }}
                    />
                )}
            </Modal>
        </Container>
    );
}